import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link } from "react-router-dom";

import Nav from "../Nav";

import { Helmet } from "react-helmet";

import { fetchVOIData, fetchForm, updateVOIData } from "../../actions";
import server from "../../api/server";
import VOIBox from './VOIBox';

const ICON_SHIELD = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M10 1.5 3.5 4v5.5C3.5 13.5 6.4 17.2 10 18.5c3.6-1.3 6.5-5 6.5-9V4L10 1.5z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_CHECK = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path
            fillRule="evenodd"
            d="M16.7 5.3a1 1 0 010 1.4l-7.5 7.5a1 1 0 01-1.4 0L3.3 9.7a1 1 0 011.4-1.4l3.8 3.8 6.8-6.8a1 1 0 011.4 0z"
            clipRule="evenodd"
        />
    </svg>
);

const ICON_PHONE = (
    <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
        <path d="M2 4a2 2 0 012-2h2.3a1 1 0 01.95.68l1.1 3.3a1 1 0 01-.5 1.2l-1.7.85a11 11 0 005.5 5.5l.86-1.7a1 1 0 011.2-.5l3.3 1.1a1 1 0 01.68.95V16a2 2 0 01-2 2h-1C7.6 18 2 12.4 2 5V4z" />
    </svg>
);

export class VOIClientSide extends Component {

    constructor(props) {
        super(props);

        this.state = {
            mobile: "",
            disabled: false
        };
    }

    componentDidMount() {
        // this.props.fetchForm(this.props.match.params.id)
        console.log(this.props);
        this.props.fetchForm(this.props.match.params.id);
        this.props.fetchVOIData(this.props.match.params.id);
    }

    startVOI = async (applicant_id, name, identification_id) => {
        this.setState({ disabled: true });
        console.log(applicant_id, name, identification_id, this.props.id, 'FLAG1');
        const response = await server.post("/startvoi", { id: applicant_id, mobile: this.state.mobile, name: name, identification_id: identification_id, application_id: this.props.id });
        this.props.updateVOIData(response.data);
        this.setState({ disabled: false });
    };

    componentDidUpdate(prevProps, prevState) {
        if (prevProps.VOI != this.props.VOI) {

        }
    }

    renderCardShell = ({ icon, title, badge, children }) => (
        <section className="rounded-2xl bg-white shadow-sm border border-[#E5E7EB] p-5 sm:p-6">
            <header className="flex items-start gap-3 mb-4">
                <span
                    className="inline-flex items-center justify-center h-10 w-10 rounded-xl flex-shrink-0"
                    style={{ backgroundColor: '#EFEAFE', color: '#5B3FE0' }}
                >
                    {icon}
                </span>
                <div className="flex-1 min-w-0">
                    <div className="flex items-center gap-2 flex-wrap">
                        <h3 className="text-base sm:text-lg font-bold text-[#1F2937]">{title}</h3>
                        {badge}
                    </div>
                </div>
            </header>
            <div className="space-y-3">{children}</div>
        </section>
    );

    renderApplicants = () => {
        const applicants = [];
        if (this.props.VOI != null) {
            Object.keys(this.props.VOI.applicants).forEach((key) => {
                const a = this.props.VOI.applicants[key];

                if (a.transaction_id != undefined) {
                    if (a.completed == false) {
                        // SMS sent, awaiting completion on phone
                        applicants.push(
                            this.renderCardShell({
                                icon: ICON_PHONE,
                                title: a.name,
                                badge: (
                                    <span
                                        className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                                        style={{ backgroundColor: '#FEF3C7', color: '#92400E' }}
                                    >
                                        <span
                                            className="inline-block h-1.5 w-1.5 rounded-full"
                                            style={{ backgroundColor: '#F59E0B' }}
                                        />
                                        Awaiting completion
                                    </span>
                                ),
                                children: (
                                    <>
                                        <p className="text-sm text-[#6B7280] leading-relaxed">
                                            Please follow the instructions sent to your phone.
                                        </p>
                                        <p className="text-sm text-[#6B7280] leading-relaxed">
                                            If you didn't receive a message, tap the button below
                                            on a <strong className="text-[#1F2937]">mobile device</strong> to complete your
                                            verification of identity.
                                        </p>
                                        <a
                                            href={`https://loangateway.au.idkit.com/${a.transaction_id}`}
                                            target="_blank"
                                            rel="noreferrer noopener"
                                            className="mt-2 inline-flex w-full sm:w-auto items-center justify-center rounded-xl px-5 py-3 text-sm font-semibold text-white shadow-md transition-transform active:scale-95"
                                            style={{ backgroundColor: '#7C5CFC' }}
                                        >
                                            Complete Verification of Identity →
                                        </a>
                                    </>
                                ),
                            })
                        );
                    } else {
                        // Done
                        applicants.push(
                            this.renderCardShell({
                                icon: ICON_CHECK,
                                title: a.name,
                                badge: (
                                    <span
                                        className="inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-semibold uppercase tracking-wide"
                                        style={{ backgroundColor: '#DCFCE7', color: '#15803D' }}
                                    >
                                        <span
                                            className="inline-block h-1.5 w-1.5 rounded-full"
                                            style={{ backgroundColor: '#16A34A' }}
                                        />
                                        Completed
                                    </span>
                                ),
                                children: (
                                    <p className="text-sm text-[#6B7280] leading-relaxed">
                                        Thank you for completing your Verification of Identity.
                                    </p>
                                ),
                            })
                        );
                    }
                } else {
                    applicants.push(
                        <VOIBox key={key} applicant_id={key} applicant={a} />
                    );
                }
            });
        }
        return applicants;
    };


    render() {
        return (
            <div
                className="min-h-screen w-full"
                style={{ backgroundColor: '#F5F6FA' }}
            >
                <Helmet>
                    {/*
                      Toggle the modern-page body styles via <html
                      className>. See client/src/index.css ".lg-modern-page"
                      rules - they override the legacy /css/loader.css
                      (which forces html/body to 100px), hide the
                      .full-loader overlay, and set the modern background
                      + font. Using <html> attributes (instead of an
                      inline <style> tag) ensures react-helmet@6.1
                      correctly REMOVES them on unmount so they don't
                      leak into /admin pages.
                    */}
                    <html className="lg-modern-page" />
                    <title>Verification of Identity - LoanGateway</title>
                    <meta name="viewport" content="width=device-width, initial-scale=1" />
                </Helmet>
                <Nav showProgress="false"></Nav>

                <main className="px-4 sm:px-6 lg:px-8 py-6 sm:py-10">
                    <div className="max-w-3xl mx-auto">
                        <Link
                            to={`/dashboard/${this.props.id}`}
                            className="inline-flex items-center gap-1.5 rounded-full bg-white border border-[#E5E7EB] px-3 py-1.5 text-xs sm:text-sm font-semibold transition-all hover:border-[#C4B5FD] hover:shadow-sm mb-5"
                            style={{ color: '#1F2937' }}
                        >
                            <svg className="h-3.5 w-3.5" viewBox="0 0 20 20" fill="currentColor" style={{ color: '#5B3FE0' }}>
                                <path
                                    fillRule="evenodd"
                                    d="M12.7 4.3a1 1 0 010 1.4L8.4 10l4.3 4.3a1 1 0 01-1.4 1.4l-5-5a1 1 0 010-1.4l5-5a1 1 0 011.4 0z"
                                    clipRule="evenodd"
                                />
                            </svg>
                            Back to dashboard
                        </Link>

                        <div className="mb-6 sm:mb-8">
                            <p
                                className="text-xs sm:text-sm font-semibold tracking-wide uppercase"
                                style={{ color: '#5B3FE0' }}
                            >
                                Your application
                            </p>
                            <h1 className="mt-2 text-2xl sm:text-3xl font-bold text-[#1F2937]">
                                Verification of Identity
                            </h1>
                            <p className="mt-2 text-sm sm:text-base text-[#6B7280] leading-relaxed">
                                Verify your identity for each applicant below. We'll send a
                                secure SMS link to complete the process. It should only take
                                a few minutes.
                            </p>
                        </div>

                        <div className="space-y-4 sm:space-y-5">
                            {this.renderApplicants()}
                        </div>
                    </div>
                </main>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({
    VOI: state.VOI,
    id: state.id
});

const mapDispatchToProps = {
    fetchVOIData,
    fetchForm,
    updateVOIData
};

export default connect(mapStateToProps, mapDispatchToProps)(VOIClientSide);
